import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../features/auth/authSlice';
import userSlice from '../features/user/userSlice';
import dashboardSlice from '../features/dashboard/dashboardSlice';
import financeSlice from '../features/finance/financeSlice';
import teamSlice from '../features/team/teamSlice';
import messageSlice from '../features/message/messageSlice';
import verificationCodeSlice from '../features/verificationCode/verificationCodeSlice';
import menuSlice from '../features/menu/menuSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    dashboard: dashboardSlice,
    finance: financeSlice,
    team: teamSlice,
    message: messageSlice,
    verificationCode: verificationCodeSlice,
    menu: menuSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
